import { Button } from "../../../components/ui/button";
import { XIcon } from "lucide-react";
import { RowSelectionState } from "@tanstack/react-table";
import React from "react";
import { DeleteRowConfirmationDialog } from "./DeleteRowConfirmationDialog";
import { useTranslation } from "react-i18next";

interface AxDataTableFloatingDockProps {
  onDeleteRows: (ids: any[]) => Promise<void>;
  rowSelection: RowSelectionState;
  onDeselectAll: () => void;
  deleting?: boolean;
}

export const AxDataTableFloatingDock: React.FC<AxDataTableFloatingDockProps> = ({
  onDeleteRows,
  rowSelection,
  onDeselectAll,
  deleting,
}) => {
  const { t } = useTranslation();
  const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
  const selectedCount = selectedIds.length;
  if (!selectedCount) {
    return null;
  }

  const deselectAllButton = (
    <Button variant="outline" size="sm" onClick={onDeselectAll} className="gap-2">
      <XIcon className="h-4 w-4" />
      Deselect All
    </Button>
  );

  const deleteButton = (
    <DeleteRowConfirmationDialog
      onConfirmDelete={() => onDeleteRows(selectedIds)}
      deleteText={t("common.deleteEntity.buttonText")}
      isLoading={deleting}
    />
  );

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 bg-background border rounded-lg shadow-lg p-4 flex items-center gap-4 animate-in fade-in slide-in-from-bottom duration-300">
      <span className="text-sm text-muted-foreground">
        {selectedCount} {selectedCount === 1 ? "item" : "items"} selected
      </span>
      <div className="flex items-center gap-2">
        {deselectAllButton}
        {deleteButton}
      </div>
    </div>
  );
};
